import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { CommonCardStyles } from './styles/Common';
import { NO_OP } from '../constants';
const groupStyles = css`
${CommonCardStyles}
display: grid;
grid-template-columns: 1fr .5fr .5fr;
grid-template-areas: 'name people lists';

  &.header {
    //font-weight: bold;
  }
  & .name {
    grid-area: name;
  }
  & .people {
    grid-area: people;
    display: flex;
    flex-direction: row;
    gap:4px;
  }
  & .lists {
    grid-area: lists;
    display: flex;
    flex-direction: row;
    gap:5px;
  }
`;

const GroupCard = styled(({ className, item: group, onSelectItem = {NO_OP} }) => {
    return (
      <div className={className} onClick = {() => onSelectItem(group)}>
        <div className='name'>
          {group.name}
        </div>
        <div className='people'>
          <span>{group.members.length}</span>
          <FontAwesomeIcon icon={faUserFriends} />
        </div>
        <div className='lists'>
          <span>{group.lists.length}</span>
          <FontAwesomeIcon icon={faList} />
        </div>
      </div>
    )
})`${groupStyles}`;

export default GroupCard;